import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/Header/Header";
import ProfileItem from "../../../components/Profile/ProfileItem";
import images from "../../../images";
import achievementsData from "../../../contanst/achievementList.json";
import { useTranslation } from "react-i18next";

const Achievements = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleAchievementClick = (achievementId) => {
    navigate(`detail/${achievementId}`);
  };

  return (
    <div className="w-full max-w-lg mx-auto min-h-screen flex flex-col bg-gray-50">
      <div className="sticky top-0 left-0 w-full z-50 bg-[#253FF6]">
        <Header
          backIcon={images.BackIcon}
          onBackClick={() => navigate(-1)}
          title={t("achievements.title")}
          textColor="text-white"
        />
      </div>

      <div className="flex-1 px-4 pb-4 space-y-4 mt-4">
        {achievementsData.map((achievement) => (
          <ProfileItem
            key={achievement.id}
            title={achievement.title}
            description={achievement.description}
            time={achievement.expiryDate}
            image={images.trophyIcon}
            onClick={() => handleAchievementClick(achievement.id)}
          />
        ))}

        {achievementsData.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            {t("achievements.noAchievements")}
          </div>
        )}
      </div>
    </div>
  );
};

export default Achievements;
